import { render, staticRenderFns } from "./signitem.vue?vue&type=template&id=7f8f6731&scoped=true&"
import script from "./signitem.vue?vue&type=script&lang=js&"
export * from "./signitem.vue?vue&type=script&lang=js&"
import style0 from "./signitem.vue?vue&type=style&index=0&id=7f8f6731&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8f6731",
  null
  
)

export default component.exports